import {
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  styled,
  tableCellClasses,
} from '@mui/material'
import { memo, useEffect } from 'react'
import { DateFormatter } from 'utils/datetime'
import numbro from 'numbro'
import {
  useFundingRatePagination,
  useUpdateFundingBaseCurrency,
} from '../Information/Tabs/FundingRate'
import { Link } from 'react-router-dom'
import { ReactComponent as IconRight } from './right.svg'
import { useCurrentPerpSymbol } from 'store/perp/hooks'

const Wrap = styled(Stack)`
  padding: 8px 24px 24px;
`
const Title = styled('h2')`
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-weight: 600;
  font-size: 18px;
  line-height: 28px;
  margin: 0;
`
const Body = styled('div')`
  padding: 16px 0;
`
const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    color: 'rgba(123, 136, 145, 1)',
    lineHeight: '18px',
    padding: '11px 16px',
    borderBottomColor: 'rgba(46, 54, 59, 1)',
  },
  [`&.${tableCellClasses.body}`]: {
    color: 'rgba(229, 234, 238, 1)',
    fontSize: 14,
    borderBottomColor: 'rgba(46, 54, 59, 1)',
  },
}))
const More = styled(Link)`
  display: inline-flex;
  align-items: center;
  font-size: 14px;
  color: rgba(149, 164, 173, 1);
`

export const FundingRateView = memo(() => {
  useUpdateFundingBaseCurrency()
  const { rows, go } = useFundingRatePagination()
  useEffect(() => {
    go(1)
  }, [go])
  const currentSymbol = useCurrentPerpSymbol()

  return (
    <Wrap>
      <Title>
        <span>Funding Rate History</span>
        <More to={`/contract/information/${currentSymbol.name}`}>
          View More <IconRight />
        </More>
      </Title>
      <Body>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <StyledTableCell>Time</StyledTableCell>
                <StyledTableCell>Funding Interval</StyledTableCell>
                <StyledTableCell>Funding Rate</StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {rows.map((row, index) => (
                <TableRow key={index}>
                  <StyledTableCell component="th" scope="row">
                    {DateFormatter.toISODateTime(row[0])}
                  </StyledTableCell>
                  <StyledTableCell>8h</StyledTableCell>
                  <StyledTableCell>
                    {numbro(row[1]).format({
                      output: 'percent',
                      mantissa: 4,
                    })}
                  </StyledTableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Body>
    </Wrap>
  )
})
